<template>
    <v-layout row wrap class="px-12 pt-6" justify-center>
        <v-flex xs12 class="headline">
            {{ $t('coupon.takeAnotherAppt.title') }}
        </v-flex>
        <v-flex xs12 class="my-2">
            {{ $t('coupon.takeAnotherAppt.text') }}
        </v-flex>
        <v-flex
            xs12
            sm7
            md4
            lg3
            my-1
            class="d-flex justify-center">
            <v-btn
                to="take-appt"
                class="button-secondary-color"
                rounded
                id="coupon-another-btn"
                @click="takeAnotherAppt"
            >
                <span class="pl-2">
                    {{ $t('coupon.takeAnotherAppt.btn') }}
                </span>
            </v-btn>
        </v-flex>
    </v-layout>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'book-another-appointment',
    computed: {
        ...mapGetters({
            serviceHasDynamicFilter: 'services/serviceHasDynamicFilter',
            isGapModeOn: 'gap/isGapModeOn',
        }),
    },
    methods: {
        ...mapActions({
            toggleHomeLoading: 'loading/toggleHomeLoading',
        }),

        takeAnotherAppt() {
            if (!this.serviceHasDynamicFilter && !this.isGapModeOn) {
                this.$store.commit('appointments/NEXT_APPOINTMENT_INFO');
            }
            this.toggleHomeLoading({ set: true });
        },
    },
};
</script>
